"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import { getTradingPair } from "@/service/api";
import rupee from "../../../public/assets/newHomeImage/rupee.svg";
import twenty from "../../../public/assets/newHomeImage/247.jpg";
import iso from "../../../public/assets/newHomeImage/iso.svg";
import money from "../../../public/assets/newHomeImage/money.svg";
import TopCrypto from "../home/TopCrypto";

const Marketing = () => {
  const [pairs, setPairs] = useState();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchTradingPairs();
  }, [""]);

  const marketingDemo = [
    {
      logo: rupee,
      title: "F.I.U. Compliant",
    },
    {
      logo: money,
      title: "Insured Funds",
    },
    {
      logo: twenty,
      title: "24*7 Support",
    },
    {
      logo: iso,
      title: "ISO/IEC 27001:2022",
    },
  ];

  const fetchTradingPairs = async () => {
    // setIsLoading(true);
    let params: any = {
      page: 1,
      sizePerPage: 100,
      pagination: false,
    };

    try {
      const response = await getTradingPair(params);
      if (response.status) {
        setPairs(response?.data?.result);
      }
    } catch (error) {
      console.error("Error fetching pairs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section
        className="w-full"
        // style={{ backgroundImage: `url(${bgImage.src})` }}
      >
        <div className="container-wrapper py-12 px-4 sm:px-6 lg:px-12 mx-auto flex flex-col gap-12 mb-[67px]">
          <div className="w-full px-2">
            <div className="flex flex-col md:flex-row md:justify-start items-center gap-6 md:gap-9 flex-wrap">
              <Cards cryptoList={marketingDemo} />
            </div>
          </div>
        </div>
      </section>
      <TopCrypto />
    </>
  );
};

export default Marketing;

const Cards = ({ cryptoList }: any) => {
  return (
    <div className="w-full flex flex-wrap justify-center gap-6">
      {cryptoList?.map((item: any, index: any) => (
        <div
          key={index}
          className="w-full sm:w-[45%] lg:w-[22%] px-4 py-4 flex items-center gap-4 bg-white top-crypto-card-shadow rounded-xl"
        >
          <Image
            onContextMenu={(e) => e.preventDefault()}
            src={item.logo}
            alt={item.title}
            className="h-12 w-12 object-contain"
          />
          <h6 className="text-[16px] md:text-[18px] text-smallText leading-6 tracking-[0.15px] font-outfit">
            {item.title}
          </h6>
        </div>
      ))}
    </div>
  );
};
